import React, { useState } from 'react';
import * as authService from '../../services/authService';
import './Login.css';

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [cargando, setCargando] = useState(false);

  // NUEVO: Función auxiliar para limpiar el error mientras el usuario escribe
  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    if (error) setError(''); // Borra el error de la pantalla al tipear
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      const data = await authService.login(username, password);
      onLoginSuccess(data.user_data, data.access);
    } catch (err) {
      if (err.response?.status === 401) setError('Credenciales incorrectas. Intente nuevamente.');
      else setError('Error de conexión con el servidor.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/DuocUC-1024x252.png"  
          alt="Logo Duoc UC"
          style={{ height: '55px', marginBottom: '15px' }}
        />
        <h2>Acceso Estacionamiento</h2>
        <p>Sistema de Gestión</p>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            {/* NUEVO: Accesibilidad con htmlFor e id */}
            <label htmlFor="username">Usuario</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={handleInputChange(setUsername)}
              placeholder="Ej: JMendoza"
              autoFocus
              disabled={cargando}
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={handleInputChange(setPassword)}
              placeholder="••••••"
              disabled={cargando}
            />
          </div>

          {error && <div className="error-msg">{error}</div>}

          <button type="submit" className="btn-login" disabled={cargando}>
            {cargando ? 'INGRESANDO...' : 'INGRESAR'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;